import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import React, { useState } from 'react';
import axios from 'axios';

function CheckBalance() {

  const [address, setAddress] = useState('');
  const [balance, setBalance] = useState('');

  const handleCheckBalance = async () => {
      try{
          const response = await axios.get(`http://localhost:4000/check-balance/${address}`);
          setBalance(response.data.balance);
      } catch(error){
          console.error('Error checking balance:', error);
      }
  };

  return (
    <Container>
    <Card border='danger'>
      <Card.Header style={{ backgroundColor:'black', color:'white'}}>Semakan Baki Akaun</Card.Header>
      <Card.Body><p>
        <Badge bg="info">Masukkan Alamat ID</Badge><br />
        <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon3">
              Address
            </InputGroup.Text>
            <Form.Control id="basic-url" aria-describedby="basic-addon3" value={address} onChange={(e) => setAddress(e.target.value)} />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon2">
              Baki Akaun
              </InputGroup.Text>
              <Form.Control id="basic-url" aria-describedby="basic-addon2" value={balance} readOnly />
              <InputGroup.Text id='basic-addon2'>SepoliaETH</InputGroup.Text>
              </InputGroup>
          <Button variant='primary' onClick={handleCheckBalance}>Semak Baki</Button></p>
      </Card.Body>
    </Card>
    </Container>
  );
};
  
export default CheckBalance;